import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contact container align-middle" }
const _hoisted_2 = { class: "container p-5" }
const _hoisted_3 = { class: "input-group mb-3 title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "inputGroup-sizing-default"
}, "標題", -1)
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "留言", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_GoogleMap = _resolveComponent("GoogleMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Title, {
      title: "聯絡我們",
      subtitle: "請聯絡我們"
    }),
    _createVNode(_component_GoogleMap),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
            type: "text",
            "aria-label": "",
            "aria-describedby": "inputGroup-sizing-default"
          }, null, 512), [
            [_vModelText, _ctx.title]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.message) = $event)),
            "aria-label": "With textarea"
          }, null, 512), [
            [_vModelText, _ctx.message]
          ])
        ]),
        _createElementVNode("button", {
          class: "btn btn-secondary w-100 mt-5",
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
          type: "submit"
        }, "Submit")
      ])
    ])
  ]))
}